import { css } from '@emotion/react';
import { IconType } from '@types';
import { AvatarGroup, AvatarIcon, AvatarIcons, colors, CommonIconAvatar, Row } from 'common-components';

type AvatarIconsWithAddPropsType = {
  items: { id: string; icon?: IconType }[]
  onAdd: () => void
};

const AvatarIconsWithAdd = ({ items, onAdd }: AvatarIconsWithAddPropsType) => (
  <Row align="middle" wrap={false} style={{ gap: 12 }}>
    {!!items?.length && (
      <AvatarGroup size="xs">
        {items.map((item) => (
          <AvatarIcon
            key={item.id}
            icon={item.icon?.iconName as AvatarIcons}
            style={{ backgroundColor: item.icon?.iconColor }}
            size="xs"
          />
        ))}
      </AvatarGroup>
    )}
    <CommonIconAvatar
      // @ts-ignore
      css={css`
        cursor: pointer;
        border: 1px dashed ${colors.gray300} !important;
      `}
      onClick={onAdd}
      size="xs"
      iconBackground={colors.white}
      borderColor={colors.gray300}
      iconColor={colors.gray500}
      icon={'Plus'}
    />
  </Row>
);

export default AvatarIconsWithAdd;
